module.exports = __webpack_public_path__ + "static/img/icon_service_abroad_serve.65e4a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_service_abroad_serve.png
// module id = lGgc
// module chunks = 1